// composables/useI18n.ts

import { useNuxtApp } from 'nuxt/app'

export const useI18n = () => {
  const nuxtApp = useNuxtApp()

  // Access the injected 't' and 'i18n' from the plugin
  const $t = nuxtApp.$t
  const $i18n = nuxtApp.$i18n

  return { t: $t, i18n: $i18n }
}
